import { toUserFriendlyAddress, useTonConnectUI } from '@tonconnect/ui-react';
import { useEffect, useState } from 'react';
import { getMe, updateUserWallet } from '../store/reducers/profile/asyncActions';
import { useAppDispatch, useAppSelector } from '../store';

const useConnectWallet = () => {
  const dispatch = useAppDispatch();
  const { userData } = useAppSelector(({ profile }) => profile);
  const [walletAddress, setWalletAddress] = useState(userData?.wallet);
  const [ui] = useTonConnectUI();

  useEffect(() => {
    ui.onStatusChange((wallet) => {
      if (wallet?.account) {
        dispatch(updateUserWallet({ wallet: toUserFriendlyAddress(wallet.account.address, true) }));
      }
    });
  }, []);

  useEffect(() => {
    if (userData?.wallet || userData?.wallet == null) {
      setWalletAddress(userData?.wallet);
    }
  }, [ui.connected, ui.account, userData]);

  const onConnect = async () => {
    if (ui.connected) {
      await ui.disconnect();
    }

    ui.openModal();
  };

  useEffect(() => {
    if (ui.modalState.closeReason) {
      dispatch(getMe());
    }
  }, [ui.modalState]);

  const disconnectWallet = async () => {
    try {
      await ui.disconnect();
      await dispatch(updateUserWallet({ wallet: null }));
      dispatch(getMe());
      setWalletAddress(null);
    } catch (error) {
      window.console.error('disconnecting error', error);
    }
  };

  return {
    onConnect, ui, disconnectWallet, walletAddress,
  };
};

export default useConnectWallet;
